import React from 'react';

interface NoEventsFoundProps {
  searchTerm: string;
  showUpcomingOnly: boolean;
  clearSearch: () => void;
  showAllEvents: () => void;
}

const NoEventsFound: React.FC<NoEventsFoundProps> = ({
  searchTerm,
  showUpcomingOnly,
  clearSearch,
  showAllEvents
}) => {
  return (
    <div className="text-center py-12">
      <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="h-16 w-16 text-gray-400 mx-auto mb-4">
        <rect width="18" height="18" x="3" y="4" rx="2" ry="2" />
        <line x1="16" x2="16" y1="2" y2="6" />
        <line x1="8" x2="8" y1="2" y2="6" />
        <line x1="3" x2="21" y1="10" y2="10" />
      </svg>
      {searchTerm ? (
        <div>
          <p className="text-gray-400 text-xl mb-2">No events found matching "{searchTerm}"</p>
          <button
            onClick={clearSearch}
            className="text-primary-500 hover:text-primary-400 text-sm"
          >
            Clear search
          </button>
        </div>
      ) : showUpcomingOnly ? (
        <div>
          <p className="text-gray-400 text-xl mb-2">No upcoming events</p>
          <button
            onClick={showAllEvents}
            className="text-primary-500 hover:text-primary-400 text-sm"
          >
            Show all events including past events
          </button>
        </div>
      ) : (
        <p className="text-gray-400 text-xl">No events available</p>
      )}
    </div>
  );
};

export default NoEventsFound;